<template>
  <div>
    <div class="banner">
      <div
        class="portalbg"
        :style="{ backgroundImage: `url(${banner.background})` }"
      >
        <div class="content">
          <img class="logo" :src="banner.logo" alt="" />
          <div class="title">
            <div class="fz54" v-for="item in banner.site_name" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <div class="module" v-if="bureauId">
        <div
          class="module1"
          v-for="(item, index) in module"
          :key="index"
          :style="{ backgroundImage: `url(${item.background})` }"
          style="position: relative"
        >
          <div class="main">
            <h1 class="moduleName">{{ item.subject }}</h1>
            <div>
              <div class="entrance" v-for="(i, v) in item.links" :key="v">
                <a
                  class="exit"
                  v-if="i.show"
                  :href="i.arrow ? i.href : 'JavaScript:void(0)'"
                  :target="i.target"
                  @click="showQrCode(item, i)"
                >
                  <a-icon
                    type="apple"
                    v-show="i.icon_type == 'IOS' || i.icon_type == 'App'"
                    style="width: 18px; color: #fff"
                    theme="filled"
                  />
                  <!-- <img
                    style="width: 18px; margin-bottom: 5px"
                    src="/portal/ios.png"
                    alt=""
                   
                  /> -->
                  <a-icon
                    type="android"
                    theme="filled"
                    v-show="i.icon_type == 'ANDROID' || i.icon_type == 'App'"
                    style="width: 18px; color: #fff"
                  />
                  <!-- <img
                    style="width: 18px; margin-bottom: 5px"
                    src="/portal/android.png"
                    alt=""
                    v-show="i.icon_type == 'ANDROID'"
                  /> -->
                  <span> {{ i.text }}</span>
                  <img
                    v-show="i.arrow"
                    style="width: 18px"
                    src="/portal/entrance.png"
                    alt=""
                  />
                </a>
                <div
                  class="qrcode"
                  v-show="item.visible"
                  @click="visibleCancel(item)"
                >
                  <img :src="i.href" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer"  v-if="bureauId">
        <div class="text">
          <div><a href="https://xyt.xcc.cn/getpcInfo?sn=1731630589024366592&language=CN&certType=8&url=*.khsdb.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
<div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1731630589024366592=*.khsdb.com.svg"width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a></div>
          <span v-html="footer.copyright_text"></span>
          <a :href="footer.icp_link_href" target="_blank">{{ footer.icp_number }}</a>
        </div>
      </div>

      <div class="mistake-prompt" v-if="!bureauId">
        当前域名未开通业务，请检查并联系业务支持：
        <br/>{{domainName}}
      </div>
    </div>
  </div>
</template>

<script>
import bureau from '../../api/bureau'
import Vue from 'vue';

export default {
  data() {
    return {
      banner: {},
      module: [],
      footer: {},
      bureauId: -11111111,
      domainName: location.host
    }
  },
  mounted(){
  },
  created() {
      bureau.getBureauId().then((res)=>{
      this.bureauId = res
      console.log(this.bureauId,'ididididid')
    }).finally(()=>{
      if(this.bureauId == -11111111){
        console.log('finally')
        this.bureauId = null
      }
    })
    this.loadPortal()
  },
  methods: {
    visibleCancel(item) {
      item.visible = false
    },
    showQrCode(item, i) {
      if (!i.arrow) {
        item.visible = true
      }
    },
    loadPortal() {
      const axios = require('axios').default
      axios
      .get('/portal/' + location.hostname + '.json')
        .then((res) => {
          console.log('res', res)
          this.banner = res.data.banner
          this.module = res.data.entrance.map((item) => {
            item.links.map((i) => {
              if (!i.href && i.text == '进入综合管理平台') {
                console.log('进入综合管理平台')
                i.href = `https://${location.host.replace(
                  'khsdb.com',
                  'site.khsdb.com'
                )}/#login`
              }
            })
            return { ...item, visible: false }
          })
          console.log('this.module ', this.module)
          this.footer = res.data.footer
          this.$ls.set('portal', res.data)
        })
        .catch((error) => {
          axios.get('/portal/jiaoyuju.khsdb.com.json').then((res) => {
            this.banner = res.data.banner
            this.module = res.data.entrance.map((item) => {
              item.links.map((i) => {
                if (i.text == '进入综合管理平台') {
                  console.log('进入综合管理平台')
                  i.href = `https://${location.host.replace(
                    'khsdb.com',
                    'site.khsdb.com'
                  )}/#login`
                }
              })
              return { ...item, visible: false }
            })
            console.log('this.module ', this.module)
            this.footer = res.data.footer
            this.$ls.set('portal', res.data)
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
html body {
  height: 100%;
}
@media screen and (min-width: 1280px) {
  div.module {
    max-width: 1240px;
  }
}

@media screen and  (max-width: 1280px) {
  div.module {
    padding-right: 10px;
    padding-left: 10px;
  }  
}
.banner {
  width: 100%;
  // padding-bottom: 200px;
  .portalbg {
    height: 375px;

    background-color: rgba(0, 0, 0, 1);
    background-position: center center;
    background-size: cover;
    .content {
      max-width: 1500px;
      margin: 0 auto;
      .logo {
        margin-top: 40px;
        margin-left: 40px;
        height: 40px;
      }
      .title {
        margin-top: 80px;
        .fz54 {
          font-size: 54px;
          text-align: center;
          color: #fff;
        }
      }
    }
  }

  .module {
    // min-width: 1280px;
    
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap !important;
    box-sizing: border-box;

    .module1 {
      background-position: center center;
      background-size: cover;
      height: 300px;
      width: 375px;
      margin: 30px 0 0 0;
      border-radius: 10px;
      padding: 40px 0 0 30px;

      .main {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .entrance {
        height: 50px;
        margin-bottom: 20px;

        .exit {
          display: inline-block;
          font-size: 18px;
          color: #fff;
          padding: 10px 15px;
          border-radius: 50px;
          border: #fff 1px solid;
          a {
            color: #fff;
          }
        }
      }
      .qrcode {
        border-radius: 10px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 280px;
        }
      }
      .moduleName {
        font-size: 50px;
        color: #fff;
        // margin-bottom: 110px;
      }
    }
  }

  .footer {
    margin-top: 100px;
    height: 100px;
    background: rgb(228, 234, 238);
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    .text {
      // margin-top: 30px;
      color: #333333;
      div {
        margin-top: 5px;
      }
      a {
        margin-left: 20px;
        color: #333333;
      }
    }
  }
}
/deep/ .ant-popover-buttons {
  display: none !important;
}

.mistake-prompt{
  display: flex;
  justify-content: center;
  width: 800px;
  text-align: center;
  margin: 60px auto 0 auto;
  color: rgb(201, 201, 202);
  font-size: 22px;
  font-weight: 300;
  border: 1px solid rgb(201, 201, 202);
  padding: 60px 50px;
  box-sizing: border-box;
  border-radius: 15px;
}
</style>
